import { useQuery } from '@tanstack/react-query';
import { paymentPlanKey, requestPaymentPlan } from './paymentPlanApi';

/**
 * The member's active payment plan for the Payment Summary card's Payment Plan slot. `data` is
 * `null` when the member has no active plan on file — a real account state, not an error.
 */
export function usePaymentPlan() {
  return useQuery({
    queryKey: paymentPlanKey,
    queryFn: requestPaymentPlan,
  });
}
